import {OrderPlacerForm} from '../../../fields/orderPlacer/types'
import {Contact} from '../../../types'

export const buildOrderPlacerForm = (contacts?: {
  orderPlacer?: Contact
  siteContact?: Contact
}): OrderPlacerForm => {
  return {
    orderPlacer: {
      name: contacts?.orderPlacer?.name ?? '',
      phoneNumber: contacts?.orderPlacer?.phoneNumber ?? undefined
    }
  }
}
